module.exports = __webpack_public_path__ + "static/media/AbandondedChurchMarshallNC2012Pencilonvintagepaper.9416f478.webp";